import { useDataLoader } from "2g-hooks/fetch";

import { ADMIN } from "b2b/api/paths";

import { isEmpty } from "2g-utils-common";

export default function useDoplnkovaSluzba({ id }) {
  return useDataLoader({
    url: ADMIN.doplnkovaSluzba(id),
    method: "get",
    lazy: isEmpty(id),
    ignoreNotFound: true
  });
}
